export const EMBARGOED_COUNTRIES = ['RU'];
